import { CircularProgress, type SkeletonOwnProps, useTheme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';
import WidgetSkeleton from './WidgetSkeleton';
import { CHART_HEIGHT } from 'components/Dashboard/shared/constants';

type Props = {
  height?: SkeletonOwnProps['height'];
  width?: SkeletonOwnProps['width'];
  sx?: SystemStyleObject;
  iconSize?: number;
};

const WidgetLoadingIndicator = ({
  height = CHART_HEIGHT,
  width = '100%',
  sx,
  iconSize = 40,
}: Props) => {
  const theme = useTheme();
  const isLightTheme = theme.palette.mode === 'light';

  return (
    <WidgetSkeleton
      height={height}
      width={width}
      sx={sx}
      animation={false}
    >
      <svg
        width={0}
        height={0}
        style={{ visibility: 'visible' }}
      >
        <defs>
          <linearGradient
            id="widget-loading-indicator-gradient"
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop
              offset="0%"
              stopColor={
                isLightTheme
                  ? theme?.blox?.colors?.bluegray
                  : theme?.blox?.colors?.lightgray
              }
            />
            <stop
              offset="100%"
              stopColor={
                isLightTheme
                  ? theme?.blox?.colors?.gray1
                  : theme?.blox?.colors?.midlightgray
              }
            />
          </linearGradient>
        </defs>
      </svg>

      <CircularProgress
        size={iconSize}
        sx={{
          'svg circle': { stroke: 'url(#widget-loading-indicator-gradient)' },
          visibility: 'visible',
        }}
      />
    </WidgetSkeleton>
  );
};

export default WidgetLoadingIndicator;
